import { createContext, useContext } from 'react';

export type GetStartedContextType = {
  infoIsComplete: boolean;
  setInfoIsComplete: (item: boolean) => void;
};
export const GetStartedContext = createContext({} as GetStartedContextType);

const useGetStartedContext = () => {
  const context = useContext(GetStartedContext);
  return context;
};

export default useGetStartedContext;
